import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SnackBarService} from "../../../../services/snack-bar.service";
import {QuestionnairesSurveysService} from "../../../../services/questionnaires-surveys.service";
import {ErrorHandlerService} from "../../../../services/error-handler.service";
import {takeUntil} from 'rxjs/operators';
//import {Partial} from "aws-sdk/clients/cloudsearchdomain";
import {SwitchBoard} from "../../../../services/SwitchBoard";
import {QuestionBase} from "../question-base/question-base";
import {DynamicFormQuestionComponent} from "../dynamic-form-question/dynamic-form-question.component";
import {QuestionControlService} from "../question-control.service";
import {InvalidControlScrollDirective} from "../invalid-control-scroll.directive";
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-dynamic-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DynamicFormQuestionComponent, InvalidControlScrollDirective,MatIconModule,MatProgressSpinnerModule],
  templateUrl: './dynamic-form.component.html',
  styleUrl: './dynamic-form.component.scss'
})
export class DynamicFormComponent {
  @Input() questions: Partial<QuestionBase<string | number>>[] | null = [];
  @Input() userId: string;
  @Input() org: string;
  @Input() clientId: string;
  @Input() questionnaireId: string;
  @Input() questionnaireName: string;
  @Input() questionnaireBucket: string;
  @Input() questionnaireBucketValue: string;
  @Input() lock: boolean;
  @Input() isCustomer: boolean;

  @Input() set sectionObj(section) {
    this.sectionId = section.id;
    this.sectionName = section.name;
  }

  @Input() s3Credentials: any;
  @Input() uploadBucket: string;
  @Input() sections: Array<any>;
  @Input() sectionIndex: number;

  @Output() saveQs: EventEmitter<void> = new EventEmitter<void>();
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  form!: FormGroup;
  payLoad = '';
  sectionId: string;
  sectionName: string;
  loader: boolean;

  constructor(
    private qcs: QuestionControlService,
    private qsService: QuestionnairesSurveysService,
    private errorHandler: ErrorHandlerService,
    public snackBar: SnackBarService,
    private switchBoard: SwitchBoard
  ) {
    this.switchBoard.onTab.pipe(takeUntil(this.destroy$)).subscribe((reponse) => {
      if (this.form.touched) {
        this.checkValidityAndSave(true);
      }
    });
  }

  ngOnInit(): void {
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase<string>[], this.lock);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit(type): void {
    if (this.form.valid) {
      this.checkValidityAndSave(type);
    } else {
      this.form.markAllAsTouched();
    }
  }

  checkValidityAndSave(type, save?): void {
    this.payLoad = this.form.getRawValue();
    _.forEach(this.questions, (control) => {
      _.forEach(this.payLoad, (value, key) => {
        if (key === control.key) {
          switch (control.type) {
            case 'Check Boxes' : {
              _.forEach(control.checkBoxes, (check, index) => {
                check.checked = value[index];
              });
              break;
            }
            case 'Multiple Choice': {
              control.multipleOptionsAnswer = value;
              break;
            }
            case 'Rating': {
              control.ratingAnswer = value;
              break;
            }
            case 'Date': {
              control.dateAnswer = value ? moment(value).format('MM/DD/YYYY') : '';
              break;
            }
            default: {
              control.answer = value;
            }
          }
        }
      });
    });
    this.saveAnswers(this.questions, type, save);
  }

  saveAnswers(questions, type, save?): void {
    this.loader = true;
    const obj = {
      sectionId: this.sectionId,
      sectionName: this.sectionName,
      questionsAnswer: questions,
      questionBucket: this.questionnaireBucketValue
    };
    this.qsService.saveClientAnswers(this.org, this.userId, this.clientId, this.questionnaireId, type, obj)
      .subscribe((response) => {
        this.loader = false;
        this.saveQs.emit(response);
        if (!save) {
          this.snackBar.showNotification(`${this.sectionName} answers Saved Successfully`, 'success');
        }
        this.form.markAsPristine();
      }, error => {
        this.handleError(error);
      });
  }

  hideChat($event): void {
    _.forEach(this.questions, (question) => {
      question.showComments = false;
    });
    const idx = _.findIndex(this.questions, {key: $event.key});
    if (idx !== -1) {
      this.questions[idx].showComments = true;
    }
  }

  handleError(error): void {
    this.loader = false;
    this.errorHandler.handleError(error);
  }

  isDirty(): boolean {
    return this.form.dirty;
  }

}
